import styled from "styled-components";
import {baseColors} from "../../../../../../themes/definitions/casino777/base-colors";

export const JbOptinReminderHeaderOuterFrameCasino777Box = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-image: 
        url(${props => props.theme.assets.images.jackpot_bet.jackpot_bet_mountains_bg_png.toString()}),
        linear-gradient(199.68deg, #8CD1BA 36.94%, ${baseColors.base02} 75.31%);
    background-blend-mode: soft-light;
    background-size: 230%;
    background-repeat: no-repeat, no-repeat;
    background-position-y: 80%;
    background-position-x: 45%;
  
`;